"use client";

import { createContext } from "react";

export type SiteInfo = {
  site: string;
  isBridgeSite: boolean;
  defaultLang: string;
  language: string;
  domain: string;
};

const SiteInfoContext = createContext<SiteInfo | null>(null);

export default SiteInfoContext;
